import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import {
  PimProduct,
  SearchResponse,
} from '../modules/pim-graphql/views/search-view/search.model';
import { LocaleService } from './locale.service';

@Injectable({
  providedIn: 'root',
})
export class PimService {
  private httpClient = inject(HttpClient);

  private locale: LocaleService;

  private readonly productTypeOrder = [
    'OT_Product',
    'OT_ProductType',
    'OT_PackageType',
    'OT_Set',
    'OT_Package',
    // 'OT_Component',
    // 'OT_ComponentGroup',
  ];

  constructor() {
    const locale = inject(LocaleService);

    this.locale = locale;
  }

  searchByTerm(searchTerm: string): Observable<PimProduct[]> {
    const pageSize: number = 1000;
    const pageNumber: number = 0;
    const { language, country } = this.locale.getCurrentLocale().pimApiContext;
    const params = new URLSearchParams({
      keyword: searchTerm,
      pageSize: pageSize.toString(),
      page: pageNumber.toString(),
    });

    this.productTypeOrder.forEach((objectType) => {
      params.append('objectTypeFacet', objectType);
    });

    const url = `${environment.globalHeader.baseUrl}/backend/pim/v1/products/${language.toLowerCase()}/${country.toLowerCase()}/search?${params.toString()}`;

    return this.httpClient.get<SearchResponse[]>(url).pipe(
      map((response) => {
        if (!response[0]) return [];

        const products = response[0].products.map((result) => {
          return {
            _id: result['_id'],
            name: result.name,
            type: result.type,
            description: result.description,
          };
        });

        return this.sortProductsByType(products);
      }),
    );
  }

  private sortProductsByType(products: PimProduct[]): PimProduct[] {
    return products.sort((a, b) => {
      const aIndex = this.productTypeOrder.indexOf(a.type);
      const bIndex = this.productTypeOrder.indexOf(b.type);

      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }

      if (aIndex !== -1 && bIndex === -1) {
        return -1;
      }
      if (aIndex === -1 && bIndex !== -1) {
        return 1;
      }

      return 0;
    });
  }
}
